var _defs, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolarity2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: "100%",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "id1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 194 35 L 329 35 L 329 246 L 194 246 Z M 194 35 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 244.417969 13.195312 L 371.710938 140.488281 L 231.019531 281.183594 L 103.722656 153.886719 Z M 244.417969 13.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 244.417969 13.195312 L 371.710938 140.488281 L 231.019531 281.183594 L 103.722656 153.886719 Z M 244.417969 13.195312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 271.121094 188.453125 C 272.300781 187.269531 273.4375 186.046875 274.527344 184.78125 C 275.621094 183.519531 276.664062 182.214844 277.65625 180.871094 C 278.652344 179.53125 279.59375 178.152344 280.488281 176.742188 C 281.382812 175.328125 282.21875 173.886719 283.007812 172.414062 C 283.792969 170.9375 284.523438 169.4375 285.199219 167.910156 C 285.875 166.382812 286.492188 164.832031 287.054688 163.257812 C 287.617188 161.683594 288.117188 160.089844 288.5625 158.476562 C 289.007812 156.867188 289.390625 155.242188 289.714844 153.601562 C 290.039062 151.960938 290.300781 150.308594 290.503906 148.652344 C 290.707031 146.992188 290.847656 145.324219 290.925781 143.65625 C 291.007812 141.984375 291.023438 140.3125 290.980469 138.640625 C 290.9375 136.96875 290.832031 135.300781 290.664062 133.632812 C 290.5 131.96875 290.269531 130.3125 289.984375 128.664062 C 289.695312 127.015625 289.34375 125.378906 288.9375 123.757812 C 288.527344 122.132812 288.058594 120.527344 287.53125 118.9375 C 287.003906 117.347656 286.421875 115.78125 285.777344 114.234375 C 285.136719 112.6875 284.4375 111.167969 283.683594 109.671875 C 282.929688 108.175781 282.121094 106.710938 281.257812 105.273438 C 280.394531 103.839844 279.480469 102.4375 278.515625 101.066406 C 277.550781 99.699219 276.535156 98.367188 275.472656 97.070312 C 274.410156 95.777344 273.300781 94.523438 272.144531 93.308594 C 270.988281 92.097656 269.792969 90.925781 268.550781 89.800781 C 267.308594 88.675781 266.027344 87.597656 264.707031 86.566406 C 263.386719 85.535156 262.03125 84.554688 260.640625 83.625 C 259.246094 82.691406 257.820312 81.8125 256.367188 80.988281 C 254.910156 80.160156 253.421875 79.386719 251.910156 78.671875 C 250.398438 77.953125 248.859375 77.292969 247.296875 76.6875 C 245.734375 76.085938 244.15625 75.539062 242.554688 75.050781 C 240.953125 74.5625 239.335938 74.132812 237.703125 73.765625 C 236.070312 73.398438 234.425781 73.089844 232.769531 72.839844 C 231.113281 72.59375 229.453125 72.40625 227.785156 72.28125 C 226.117188 72.15625 224.445312 72.089844 222.773438 72.089844 L 222.785156 77.023438 C 224.855469 77.027344 226.917969 77.132812 228.980469 77.339844 C 231.039062 77.546875 233.085938 77.851562 235.113281 78.261719 C 237.144531 78.667969 239.152344 79.171875 241.132812 79.777344 C 243.113281 80.382812 245.0625 81.082031 246.972656 81.878906 C 248.886719 82.671875 250.757812 83.558594 252.582031 84.539062 C 254.410156 85.515625 256.183594 86.582031 257.90625 87.734375 C 259.628906 88.886719 261.292969 90.121094 262.894531 91.4375 C 264.496094 92.753906 266.027344 94.144531 267.492188 95.609375 C 268.960938 97.078125 270.351562 98.609375 271.664062 100.210938 C 272.980469 101.816406 274.214844 103.476562 275.367188 105.199219 C 276.519531 106.921875 277.582031 108.699219 278.5625 110.523438 C 279.539062 112.351562 280.425781 114.222656 281.21875 116.136719 C 282.015625 118.046875 282.714844 119.996094 283.316406 121.976562 C 283.921875 123.960938 284.425781 125.964844 284.832031 127.996094 C 285.238281 130.027344 285.542969 132.070312 285.75 134.132812 C 285.957031 136.191406 286.058594 138.257812 286.0625 140.328125 C 286.066406 142.394531 285.96875 144.460938 285.765625 146.519531 C 285.566406 148.578125 285.265625 150.625 284.863281 152.652344 C 284.464844 154.683594 283.964844 156.6875 283.367188 158.664062 C 282.769531 160.644531 282.074219 162.589844 281.285156 164.5 C 280.496094 166.410156 279.613281 168.277344 278.640625 170.101562 C 277.667969 171.925781 276.609375 173.699219 275.460938 175.417969 C 274.3125 177.136719 273.082031 178.792969 271.773438 180.390625 C 270.460938 181.988281 269.074219 183.519531 267.613281 184.980469 C 266.152344 186.441406 264.621094 187.824219 263.023438 189.136719 C 261.425781 190.445312 259.769531 191.675781 258.046875 192.820312 C 256.328125 193.96875 254.558594 195.027344 252.734375 196 C 250.910156 196.972656 249.042969 197.855469 247.132812 198.644531 C 245.21875 199.429688 243.273438 200.125 241.296875 200.722656 C 239.316406 201.320312 237.3125 201.816406 235.28125 202.21875 C 233.253906 202.617188 231.207031 202.917969 229.148438 203.117188 C 227.089844 203.316406 225.023438 203.414062 222.953125 203.410156 L 195.070312 203.371094 L 195.082031 208.304688 L 222.964844 208.3125 C 227.441406 208.332031 231.875 207.914062 236.265625 207.054688 C 240.652344 206.199219 244.914062 204.917969 249.046875 203.210938 C 253.179688 201.507812 257.105469 199.414062 260.820312 196.929688 C 264.535156 194.445312 267.96875 191.617188 271.121094 188.453125 Z M 253.613281 170.945312 C 255.121094 169.4375 256.507812 167.828125 257.777344 166.113281 C 259.046875 164.402344 260.179688 162.605469 261.183594 160.726562 C 262.1875 158.84375 263.046875 156.902344 263.761719 154.890625 C 264.480469 152.882812 265.042969 150.832031 265.457031 148.742188 C 265.871094 146.648438 266.125 144.535156 266.226562 142.40625 C 266.328125 140.273438 266.273438 138.144531 266.0625 136.019531 C 265.851562 133.898438 265.484375 131.800781 264.960938 129.726562 C 264.4375 127.65625 263.769531 125.636719 262.949219 123.664062 C 262.128906 121.6875 261.167969 119.785156 260.070312 117.953125 C 258.96875 116.121094 257.742188 114.378906 256.386719 112.726562 C 255.027344 111.074219 253.558594 109.53125 251.976562 108.097656 C 250.390625 106.660156 248.710938 105.347656 246.9375 104.160156 C 245.160156 102.972656 243.308594 101.917969 241.375 101.003906 C 239.445312 100.085938 237.457031 99.320312 235.414062 98.695312 C 233.371094 98.074219 231.296875 97.601562 229.183594 97.285156 C 227.070312 96.96875 224.949219 96.808594 222.816406 96.804688 L 222.824219 101.746094 C 224.082031 101.75 225.339844 101.8125 226.59375 101.9375 C 227.847656 102.0625 229.09375 102.25 230.328125 102.496094 C 231.566406 102.742188 232.785156 103.050781 233.992188 103.417969 C 235.199219 103.785156 236.386719 104.210938 237.550781 104.695312 C 238.714844 105.179688 239.851562 105.71875 240.964844 106.3125 C 242.078125 106.910156 243.15625 107.558594 244.207031 108.257812 C 245.253906 108.960938 246.269531 109.710938 247.242188 110.511719 C 248.21875 111.3125 249.152344 112.160156 250.042969 113.050781 C 250.9375 113.941406 251.785156 114.875 252.585938 115.851562 C 253.386719 116.828125 254.136719 117.839844 254.839844 118.886719 C 255.539062 119.9375 256.1875 121.015625 256.785156 122.128906 C 257.378906 123.242188 257.921875 124.378906 258.402344 125.542969 C 258.886719 126.707031 259.3125 127.894531 259.679688 129.101562 C 260.050781 130.304688 260.355469 131.527344 260.605469 132.765625 C 260.851562 134 261.039062 135.246094 261.164062 136.5 C 261.289062 137.753906 261.351562 139.011719 261.355469 140.269531 C 261.355469 141.53125 261.296875 142.789062 261.175781 144.039062 C 261.054688 145.292969 260.871094 146.539062 260.625 147.773438 C 260.382812 149.011719 260.078125 150.230469 259.714844 151.433594 C 259.351562 152.640625 258.929688 153.824219 258.445312 154.988281 C 257.964844 156.152344 257.429688 157.289062 256.835938 158.398438 C 256.246094 159.507812 255.601562 160.585938 254.902344 161.632812 C 254.203125 162.679688 253.453125 163.6875 252.65625 164.660156 C 251.859375 165.632812 251.015625 166.566406 250.125 167.453125 C 249.234375 168.34375 248.304688 169.1875 247.332031 169.984375 C 246.355469 170.78125 245.347656 171.53125 244.300781 172.226562 C 243.253906 172.925781 242.175781 173.570312 241.066406 174.164062 C 239.953125 174.753906 238.816406 175.292969 237.652344 175.769531 C 236.492188 176.25 235.304688 176.671875 234.101562 177.035156 C 232.894531 177.398438 231.675781 177.703125 230.441406 177.945312 C 229.203125 178.191406 227.960938 178.371094 226.707031 178.492188 C 225.453125 178.613281 224.195312 178.675781 222.933594 178.671875 L 195.015625 178.628906 L 195.027344 183.566406 L 222.949219 183.609375 C 225.796875 183.621094 228.621094 183.351562 231.417969 182.804688 C 234.210938 182.253906 236.925781 181.4375 239.558594 180.351562 C 242.191406 179.265625 244.6875 177.929688 247.054688 176.347656 C 249.417969 174.761719 251.605469 172.960938 253.613281 170.945312 Z M 262.382812 179.714844 C 264.316406 177.777344 266.097656 175.710938 267.726562 173.511719 C 269.355469 171.3125 270.8125 169.003906 272.101562 166.589844 C 273.390625 164.171875 274.492188 161.675781 275.410156 159.097656 C 276.332031 156.515625 277.054688 153.882812 277.585938 151.195312 C 278.113281 148.507812 278.445312 145.796875 278.574219 143.058594 C 278.707031 140.320312 278.632812 137.589844 278.363281 134.863281 C 278.089844 132.132812 277.617188 129.441406 276.949219 126.78125 C 276.277344 124.121094 275.417969 121.523438 274.363281 118.988281 C 273.3125 116.457031 272.078125 114.011719 270.667969 111.660156 C 269.253906 109.304688 267.679688 107.070312 265.9375 104.945312 C 264.195312 102.824219 262.308594 100.839844 260.277344 98.996094 C 258.242188 97.152344 256.085938 95.46875 253.804688 93.941406 C 251.527344 92.414062 249.144531 91.0625 246.667969 89.882812 C 244.1875 88.707031 241.636719 87.71875 239.011719 86.917969 C 236.390625 86.117188 233.722656 85.511719 231.011719 85.105469 C 228.300781 84.695312 225.574219 84.488281 222.832031 84.484375 L 222.804688 89.386719 C 224.441406 89.429688 226.074219 89.550781 227.703125 89.753906 C 229.328125 89.953125 230.941406 90.230469 232.542969 90.589844 C 234.144531 90.945312 235.722656 91.378906 237.28125 91.886719 C 238.84375 92.398438 240.371094 92.980469 241.875 93.640625 C 243.378906 94.296875 244.847656 95.023438 246.28125 95.824219 C 247.714844 96.625 249.105469 97.488281 250.453125 98.421875 C 251.804688 99.355469 253.105469 100.351562 254.359375 101.410156 C 255.613281 102.472656 256.8125 103.589844 257.960938 104.761719 C 259.105469 105.9375 260.195312 107.164062 261.222656 108.445312 C 262.25 109.722656 263.210938 111.050781 264.113281 112.421875 C 265.011719 113.792969 265.84375 115.207031 266.609375 116.660156 C 267.371094 118.113281 268.0625 119.597656 268.683594 121.117188 C 269.304688 122.636719 269.847656 124.179688 270.320312 125.75 C 270.789062 127.324219 271.183594 128.914062 271.5 130.523438 C 271.816406 132.128906 272.058594 133.75 272.21875 135.382812 C 272.378906 137.011719 272.460938 138.648438 272.460938 140.289062 C 272.464844 141.925781 272.386719 143.5625 272.230469 145.191406 C 272.078125 146.824219 271.84375 148.441406 271.53125 150.050781 C 271.21875 151.65625 270.828125 153.246094 270.363281 154.816406 C 269.894531 156.386719 269.355469 157.929688 268.738281 159.445312 C 268.125 160.964844 267.4375 162.445312 266.675781 163.898438 C 265.917969 165.347656 265.089844 166.757812 264.195312 168.125 C 263.300781 169.496094 262.339844 170.820312 261.316406 172.09375 C 260.292969 173.371094 259.207031 174.59375 258.066406 175.765625 C 256.921875 176.9375 255.726562 178.050781 254.476562 179.105469 C 253.226562 180.160156 251.925781 181.152344 250.578125 182.082031 C 249.230469 183.011719 247.84375 183.875 246.414062 184.667969 C 244.980469 185.464844 243.515625 186.1875 242.015625 186.839844 C 240.511719 187.492188 238.984375 188.070312 237.425781 188.574219 C 235.867188 189.082031 234.289062 189.507812 232.691406 189.859375 C 231.089844 190.210938 229.476562 190.488281 227.851562 190.683594 C 226.226562 190.878906 224.59375 190.996094 222.953125 191.03125 L 195.050781 190.988281 L 195.066406 195.925781 L 222.964844 195.96875 C 226.628906 195.984375 230.253906 195.640625 233.847656 194.933594 C 237.4375 194.230469 240.925781 193.179688 244.308594 191.78125 C 247.6875 190.386719 250.898438 188.671875 253.9375 186.636719 C 256.976562 184.601562 259.785156 182.289062 262.363281 179.695312 Z M 288.648438 205.976562 C 289.71875 204.90625 290.765625 203.804688 291.785156 202.683594 C 292.800781 201.558594 293.792969 200.410156 294.753906 199.238281 C 295.714844 198.0625 296.648438 196.867188 297.550781 195.648438 C 298.453125 194.429688 299.324219 193.1875 300.167969 191.925781 C 301.007812 190.664062 301.820312 189.382812 302.597656 188.082031 C 303.375 186.777344 304.125 185.457031 304.835938 184.121094 C 305.550781 182.78125 306.230469 181.425781 306.878906 180.050781 C 307.523438 178.679688 308.136719 177.292969 308.71875 175.890625 C 309.296875 174.488281 309.839844 173.070312 310.347656 171.640625 C 310.859375 170.210938 311.332031 168.769531 311.769531 167.316406 C 312.210938 165.863281 312.613281 164.398438 312.976562 162.925781 C 313.34375 161.453125 313.675781 159.972656 313.96875 158.480469 C 314.261719 156.992188 314.519531 155.496094 314.738281 153.992188 C 314.960938 152.488281 315.144531 150.984375 315.289062 149.46875 C 315.433594 147.957031 315.542969 146.445312 315.617188 144.925781 C 315.6875 143.410156 315.722656 141.890625 315.71875 140.371094 C 315.71875 138.851562 315.675781 137.332031 315.601562 135.816406 C 315.523438 134.296875 315.40625 132.78125 315.257812 131.269531 C 315.105469 129.757812 314.917969 128.25 314.691406 126.746094 C 314.464844 125.242188 314.203125 123.746094 313.902344 122.253906 C 313.605469 120.765625 313.269531 119.28125 312.898438 117.808594 C 312.523438 116.332031 312.117188 114.867188 311.671875 113.414062 C 311.230469 111.957031 310.75 110.515625 310.238281 109.082031 C 309.722656 107.652344 309.171875 106.234375 308.589844 104.828125 C 308.003906 103.425781 307.386719 102.035156 306.734375 100.660156 C 306.082031 99.285156 305.398438 97.925781 304.679688 96.585938 C 303.960938 95.246094 303.210938 93.921875 302.425781 92.617188 C 301.640625 91.3125 300.828125 90.027344 299.980469 88.761719 C 299.132812 87.5 298.257812 86.253906 297.351562 85.03125 C 296.441406 83.8125 295.507812 82.613281 294.539062 81.433594 C 293.574219 80.257812 292.582031 79.105469 291.558594 77.980469 C 290.535156 76.851562 289.484375 75.75 288.410156 74.671875 C 286.261719 72.511719 284.015625 70.464844 281.664062 68.523438 C 279.316406 66.585938 276.875 64.769531 274.347656 63.070312 C 271.820312 61.375 269.210938 59.804688 266.53125 58.363281 C 263.847656 56.921875 261.097656 55.617188 258.289062 54.449219 C 255.476562 53.28125 252.613281 52.253906 249.703125 51.367188 C 246.789062 50.480469 243.839844 49.742188 240.855469 49.148438 C 237.871094 48.550781 234.867188 48.105469 231.839844 47.808594 C 228.8125 47.511719 225.777344 47.363281 222.734375 47.367188 L 222.765625 52.285156 C 224.203125 52.289062 225.640625 52.324219 227.078125 52.398438 C 228.515625 52.472656 229.949219 52.578125 231.382812 52.722656 C 232.8125 52.867188 234.242188 53.042969 235.664062 53.257812 C 237.089844 53.46875 238.503906 53.71875 239.917969 54 C 241.328125 54.285156 242.730469 54.601562 244.128906 54.953125 C 245.523438 55.304688 246.910156 55.691406 248.289062 56.109375 C 249.664062 56.53125 251.03125 56.984375 252.386719 57.46875 C 253.742188 57.957031 255.085938 58.476562 256.414062 59.027344 C 257.746094 59.582031 259.058594 60.167969 260.359375 60.78125 C 261.664062 61.398438 262.949219 62.050781 264.21875 62.730469 C 265.488281 63.410156 266.738281 64.121094 267.976562 64.859375 C 269.210938 65.601562 270.425781 66.375 271.625 67.175781 C 272.820312 67.976562 274 68.804688 275.15625 69.664062 C 276.3125 70.523438 277.445312 71.410156 278.558594 72.324219 C 279.675781 73.238281 280.765625 74.179688 281.832031 75.148438 C 282.898438 76.117188 283.941406 77.109375 284.960938 78.128906 C 285.980469 79.144531 286.972656 80.1875 287.941406 81.257812 C 288.910156 82.324219 289.847656 83.414062 290.765625 84.527344 C 291.679688 85.640625 292.566406 86.777344 293.421875 87.933594 C 294.28125 89.089844 295.113281 90.265625 295.914062 91.464844 C 296.714844 92.660156 297.484375 93.878906 298.226562 95.113281 C 298.96875 96.347656 299.679688 97.601562 300.359375 98.871094 C 301.039062 100.140625 301.6875 101.425781 302.304688 102.726562 C 302.921875 104.027344 303.507812 105.34375 304.058594 106.675781 C 304.613281 108.003906 305.132812 109.347656 305.617188 110.703125 C 306.105469 112.058594 306.558594 113.421875 306.976562 114.800781 C 307.398438 116.175781 307.785156 117.5625 308.136719 118.960938 C 308.488281 120.355469 308.804688 121.761719 309.085938 123.171875 C 309.371094 124.582031 309.617188 126 309.832031 127.421875 C 310.042969 128.847656 310.222656 130.273438 310.367188 131.707031 C 310.507812 133.136719 310.617188 134.574219 310.691406 136.007812 C 310.761719 137.445312 310.800781 138.882812 310.800781 140.324219 C 310.804688 141.761719 310.773438 143.199219 310.703125 144.636719 C 310.632812 146.074219 310.53125 147.507812 310.390625 148.9375 C 310.253906 150.371094 310.078125 151.796875 309.871094 153.21875 C 309.660156 154.644531 309.417969 156.058594 309.140625 157.46875 C 308.859375 158.878906 308.546875 160.285156 308.199219 161.679688 C 307.851562 163.074219 307.472656 164.457031 307.054688 165.835938 C 306.640625 167.210938 306.191406 168.574219 305.707031 169.929688 C 305.226562 171.285156 304.710938 172.625 304.160156 173.953125 C 303.613281 175.28125 303.03125 176.59375 302.417969 177.894531 C 301.804688 179.195312 301.160156 180.476562 300.484375 181.746094 C 299.808594 183.011719 299.101562 184.261719 298.363281 185.496094 C 297.625 186.730469 296.859375 187.941406 296.0625 189.136719 C 295.261719 190.332031 294.4375 191.507812 293.582031 192.660156 C 292.726562 193.816406 291.84375 194.949219 290.933594 196.058594 C 290.019531 197.171875 289.082031 198.257812 288.117188 199.320312 C 287.15625 200.386719 286.164062 201.425781 285.148438 202.441406 C 284.132812 203.457031 283.09375 204.449219 282.027344 205.414062 C 280.964844 206.378906 279.875 207.316406 278.765625 208.226562 C 277.65625 209.136719 276.523438 210.019531 275.367188 210.875 C 274.214844 211.730469 273.039062 212.558594 271.84375 213.355469 C 270.648438 214.152344 269.4375 214.917969 268.203125 215.65625 C 266.96875 216.394531 265.71875 217.101562 264.453125 217.777344 C 263.183594 218.453125 261.902344 219.097656 260.601562 219.710938 C 259.300781 220.324219 257.988281 220.90625 256.660156 221.453125 C 255.332031 222.003906 253.988281 222.519531 252.636719 223 C 251.28125 223.484375 249.917969 223.933594 248.542969 224.347656 C 247.164062 224.765625 245.78125 225.144531 244.382812 225.492188 C 242.988281 225.839844 241.585938 226.152344 240.175781 226.433594 C 238.765625 226.710938 237.347656 226.957031 235.925781 227.164062 C 234.503906 227.375 233.078125 227.546875 231.644531 227.6875 C 230.214844 227.824219 228.777344 227.929688 227.34375 227.996094 C 225.90625 228.066406 224.46875 228.097656 223.027344 228.097656 L 195.15625 228.074219 L 195.167969 233.007812 L 223.023438 233.050781 C 226.066406 233.0625 229.097656 232.925781 232.125 232.640625 C 235.152344 232.351562 238.160156 231.914062 241.140625 231.332031 C 244.125 230.746094 247.070312 230.015625 249.980469 229.140625 C 252.890625 228.261719 255.75 227.246094 258.558594 226.085938 C 261.367188 224.925781 264.113281 223.628906 266.792969 222.199219 C 269.46875 220.765625 272.074219 219.207031 274.597656 217.515625 C 277.121094 215.828125 279.554688 214.015625 281.898438 212.085938 C 284.242188 210.15625 286.488281 208.113281 288.628906 205.960938 Z M 244.878906 162.210938 C 245.957031 161.132812 246.949219 159.980469 247.855469 158.757812 C 248.765625 157.53125 249.578125 156.246094 250.292969 154.902344 C 251.011719 153.558594 251.625 152.167969 252.136719 150.730469 C 252.648438 149.292969 253.054688 147.828125 253.347656 146.332031 C 253.644531 144.832031 253.828125 143.324219 253.898438 141.800781 C 253.972656 140.273438 253.933594 138.753906 253.78125 137.234375 C 253.628906 135.714844 253.367188 134.214844 252.992188 132.734375 C 252.621094 131.25 252.140625 129.804688 251.554688 128.394531 C 250.96875 126.984375 250.28125 125.621094 249.496094 124.3125 C 248.707031 123.003906 247.832031 121.757812 246.859375 120.574219 C 245.890625 119.394531 244.839844 118.289062 243.707031 117.261719 C 242.574219 116.234375 241.375 115.296875 240.101562 114.445312 C 238.832031 113.597656 237.507812 112.84375 236.125 112.1875 C 234.746094 111.535156 233.324219 110.984375 231.863281 110.539062 C 230.402344 110.09375 228.917969 109.757812 227.40625 109.53125 C 225.898438 109.304688 224.378906 109.1875 222.851562 109.183594 L 222.855469 114.121094 C 223.710938 114.121094 224.5625 114.164062 225.414062 114.25 C 226.265625 114.335938 227.109375 114.460938 227.949219 114.628906 C 228.789062 114.800781 229.617188 115.007812 230.433594 115.257812 C 231.253906 115.507812 232.058594 115.796875 232.847656 116.125 C 233.636719 116.453125 234.410156 116.820312 235.164062 117.222656 C 235.917969 117.625 236.652344 118.066406 237.363281 118.542969 C 238.074219 119.019531 238.761719 119.527344 239.425781 120.070312 C 240.085938 120.617188 240.71875 121.191406 241.324219 121.796875 C 241.929688 122.402344 242.503906 123.035156 243.046875 123.695312 C 243.59375 124.359375 244.101562 125.042969 244.578125 125.757812 C 245.054688 126.46875 245.492188 127.199219 245.898438 127.957031 C 246.300781 128.710938 246.667969 129.480469 246.996094 130.273438 C 247.324219 131.0625 247.613281 131.867188 247.863281 132.6875 C 248.113281 133.503906 248.320312 134.332031 248.488281 135.171875 C 248.65625 136.011719 248.785156 136.855469 248.871094 137.707031 C 248.953125 138.558594 248.996094 139.410156 249 140.265625 C 249 141.121094 248.960938 141.972656 248.878906 142.824219 C 248.792969 143.675781 248.671875 144.519531 248.503906 145.355469 C 248.339844 146.195312 248.132812 147.023438 247.886719 147.839844 C 247.640625 148.660156 247.351562 149.460938 247.027344 150.25 C 246.703125 151.042969 246.335938 151.8125 245.933594 152.566406 C 245.535156 153.320312 245.097656 154.050781 244.621094 154.761719 C 244.148438 155.472656 243.640625 156.15625 243.097656 156.816406 C 242.558594 157.476562 241.984375 158.109375 241.382812 158.710938 C 240.777344 159.316406 240.144531 159.886719 239.484375 160.429688 C 238.824219 160.972656 238.140625 161.480469 237.429688 161.953125 C 236.71875 162.425781 235.988281 162.863281 235.234375 163.265625 C 234.480469 163.667969 233.710938 164.03125 232.921875 164.359375 C 232.132812 164.683594 231.328125 164.96875 230.511719 165.21875 C 229.691406 165.464844 228.863281 165.671875 228.027344 165.835938 C 227.1875 166 226.34375 166.125 225.492188 166.207031 C 224.644531 166.289062 223.789062 166.332031 222.933594 166.328125 L 194.996094 166.25 L 195.019531 171.1875 L 222.945312 171.230469 C 224.984375 171.238281 227 171.046875 228.996094 170.65625 C 230.996094 170.265625 232.933594 169.679688 234.816406 168.90625 C 236.695312 168.128906 238.480469 167.175781 240.171875 166.046875 C 241.863281 164.917969 243.425781 163.632812 244.863281 162.191406 Z M 279.890625 197.222656 C 281.289062 195.828125 282.628906 194.382812 283.917969 192.886719 C 285.207031 191.390625 286.441406 189.851562 287.617188 188.265625 C 288.792969 186.679688 289.910156 185.054688 290.964844 183.386719 C 292.019531 181.71875 293.011719 180.011719 293.941406 178.269531 C 294.871094 176.527344 295.734375 174.753906 296.535156 172.949219 C 297.332031 171.144531 298.0625 169.308594 298.726562 167.449219 C 299.390625 165.589844 299.984375 163.707031 300.511719 161.804688 C 301.035156 159.898438 301.488281 157.976562 301.871094 156.039062 C 302.253906 154.101562 302.566406 152.152344 302.804688 150.191406 C 303.042969 148.226562 303.210938 146.261719 303.304688 144.285156 C 303.398438 142.3125 303.421875 140.335938 303.371094 138.359375 C 303.316406 136.382812 303.195312 134.410156 302.996094 132.445312 C 302.800781 130.476562 302.53125 128.519531 302.191406 126.570312 C 301.851562 124.621094 301.4375 122.6875 300.953125 120.769531 C 300.472656 118.851562 299.917969 116.953125 299.296875 115.074219 C 298.671875 113.199219 297.980469 111.34375 297.222656 109.519531 C 296.460938 107.691406 295.636719 105.894531 294.746094 104.125 C 293.855469 102.359375 292.898438 100.625 291.878906 98.929688 C 290.859375 97.234375 289.78125 95.574219 288.640625 93.957031 C 287.5 92.339844 286.300781 90.765625 285.042969 89.234375 C 283.785156 87.707031 282.476562 86.222656 281.109375 84.789062 C 279.746094 83.355469 278.328125 81.976562 276.859375 80.644531 C 275.394531 79.316406 273.878906 78.042969 272.320312 76.824219 C 270.757812 75.605469 269.15625 74.445312 267.511719 73.347656 C 265.863281 72.246094 264.179688 71.207031 262.460938 70.230469 C 260.738281 69.253906 258.984375 68.339844 257.195312 67.496094 C 255.40625 66.648438 253.589844 65.867188 251.742188 65.152344 C 249.898438 64.4375 248.027344 63.792969 246.136719 63.21875 C 244.242188 62.640625 242.332031 62.136719 240.402344 61.699219 C 238.472656 61.265625 236.527344 60.902344 234.574219 60.609375 C 232.617188 60.316406 230.652344 60.097656 228.679688 59.949219 C 226.710938 59.800781 224.734375 59.726562 222.757812 59.722656 L 222.765625 64.664062 C 223.996094 64.675781 225.222656 64.71875 226.449219 64.792969 C 227.679688 64.867188 228.902344 64.96875 230.125 65.101562 C 231.347656 65.234375 232.566406 65.394531 233.78125 65.589844 C 234.996094 65.78125 236.207031 66.003906 237.410156 66.253906 C 238.613281 66.503906 239.8125 66.785156 241.003906 67.09375 C 242.195312 67.402344 243.375 67.742188 244.550781 68.109375 C 245.726562 68.476562 246.890625 68.871094 248.046875 69.296875 C 249.199219 69.71875 250.34375 70.171875 251.476562 70.652344 C 252.613281 71.132812 253.734375 71.640625 254.839844 72.171875 C 255.949219 72.707031 257.046875 73.269531 258.125 73.855469 C 259.207031 74.445312 260.273438 75.058594 261.328125 75.699219 C 262.378906 76.339844 263.414062 77.003906 264.433594 77.695312 C 265.453125 78.382812 266.453125 79.097656 267.4375 79.835938 C 268.421875 80.578125 269.390625 81.339844 270.335938 82.125 C 271.285156 82.910156 272.214844 83.71875 273.121094 84.550781 C 274.03125 85.382812 274.917969 86.234375 275.785156 87.109375 C 276.648438 87.984375 277.496094 88.878906 278.320312 89.796875 C 279.140625 90.710938 279.941406 91.644531 280.71875 92.601562 C 281.496094 93.554688 282.25 94.527344 282.980469 95.519531 C 283.710938 96.511719 284.417969 97.519531 285.097656 98.542969 C 285.78125 99.570312 286.433594 100.613281 287.066406 101.667969 C 287.695312 102.726562 288.300781 103.796875 288.878906 104.886719 C 289.457031 105.972656 290.007812 107.070312 290.53125 108.183594 C 291.058594 109.296875 291.554688 110.425781 292.023438 111.5625 C 292.492188 112.699219 292.933594 113.847656 293.347656 115.007812 C 293.761719 116.164062 294.148438 117.332031 294.503906 118.511719 C 294.859375 119.6875 295.1875 120.875 295.488281 122.066406 C 295.785156 123.261719 296.054688 124.460938 296.296875 125.667969 C 296.535156 126.875 296.746094 128.085938 296.929688 129.300781 C 297.109375 130.519531 297.261719 131.738281 297.382812 132.960938 C 297.503906 134.1875 297.59375 135.410156 297.65625 136.640625 C 297.71875 137.867188 297.75 139.097656 297.753906 140.324219 C 297.753906 141.554688 297.726562 142.785156 297.667969 144.011719 C 297.609375 145.238281 297.523438 146.464844 297.402344 147.6875 C 297.285156 148.910156 297.136719 150.132812 296.960938 151.347656 C 296.785156 152.5625 296.578125 153.773438 296.339844 154.980469 C 296.101562 156.183594 295.835938 157.382812 295.542969 158.578125 C 295.246094 159.769531 294.921875 160.953125 294.570312 162.128906 C 294.214844 163.308594 293.835938 164.472656 293.425781 165.632812 C 293.015625 166.789062 292.574219 167.9375 292.109375 169.074219 C 291.644531 170.207031 291.148438 171.332031 290.628906 172.445312 C 290.105469 173.554688 289.558594 174.65625 288.984375 175.738281 C 288.410156 176.824219 287.808594 177.894531 287.179688 178.949219 C 286.554688 180.003906 285.902344 181.042969 285.222656 182.066406 C 284.546875 183.089844 283.84375 184.097656 283.117188 185.085938 C 282.386719 186.074219 281.636719 187.046875 280.863281 188 C 280.085938 188.949219 279.289062 189.882812 278.46875 190.796875 C 277.648438 191.710938 276.808594 192.601562 275.941406 193.472656 C 275.078125 194.34375 274.195312 195.195312 273.289062 196.023438 C 272.382812 196.851562 271.457031 197.660156 270.511719 198.441406 C 269.566406 199.226562 268.601562 199.984375 267.621094 200.71875 C 266.636719 201.457031 265.636719 202.167969 264.621094 202.855469 C 263.601562 203.542969 262.570312 204.203125 261.519531 204.839844 C 260.46875 205.476562 259.40625 206.085938 258.324219 206.671875 C 257.246094 207.257812 256.152344 207.8125 255.042969 208.34375 C 253.9375 208.875 252.816406 209.378906 251.6875 209.855469 C 250.554688 210.332031 249.410156 210.78125 248.257812 211.203125 C 247.101562 211.621094 245.941406 212.011719 244.765625 212.378906 C 243.59375 212.742188 242.410156 213.074219 241.222656 213.382812 C 240.03125 213.6875 238.835938 213.964844 237.632812 214.210938 C 236.429688 214.457031 235.21875 214.675781 234.003906 214.863281 C 232.792969 215.054688 231.574219 215.210938 230.351562 215.339844 C 229.128906 215.46875 227.902344 215.566406 226.675781 215.636719 C 225.449219 215.707031 224.222656 215.746094 222.992188 215.753906 L 195.121094 215.707031 L 195.140625 220.648438 L 223.003906 220.691406 C 225.640625 220.703125 228.269531 220.582031 230.894531 220.332031 C 233.519531 220.082031 236.125 219.707031 238.710938 219.199219 C 241.296875 218.691406 243.851562 218.058594 246.371094 217.296875 C 248.894531 216.539062 251.375 215.65625 253.808594 214.648438 C 256.242188 213.644531 258.621094 212.519531 260.945312 211.28125 C 263.265625 210.039062 265.519531 208.6875 267.710938 207.222656 C 269.898438 205.757812 272.007812 204.1875 274.039062 202.515625 C 276.070312 200.839844 278.015625 199.070312 279.871094 197.203125 Z M 328.082031 140.371094 C 328.078125 138.652344 328.035156 136.929688 327.945312 135.210938 C 327.859375 133.488281 327.730469 131.773438 327.558594 130.058594 C 327.386719 128.34375 327.175781 126.636719 326.917969 124.933594 C 326.664062 123.230469 326.367188 121.535156 326.03125 119.84375 C 325.691406 118.15625 325.3125 116.476562 324.890625 114.804688 C 324.46875 113.132812 324.007812 111.472656 323.507812 109.824219 C 323.003906 108.175781 322.460938 106.542969 321.878906 104.917969 C 321.296875 103.296875 320.675781 101.691406 320.011719 100.097656 C 319.351562 98.507812 318.652344 96.933594 317.914062 95.375 C 317.175781 93.816406 316.398438 92.277344 315.585938 90.757812 C 314.769531 89.238281 313.921875 87.738281 313.03125 86.261719 C 312.144531 84.785156 311.222656 83.328125 310.265625 81.894531 C 309.304688 80.460938 308.3125 79.054688 307.285156 77.667969 C 306.257812 76.285156 305.195312 74.925781 304.101562 73.59375 C 303.007812 72.261719 301.878906 70.953125 300.722656 69.675781 C 299.5625 68.398438 298.375 67.152344 297.15625 65.933594 C 295.9375 64.714844 294.6875 63.523438 293.410156 62.367188 C 292.132812 61.207031 290.828125 60.082031 289.496094 58.988281 C 288.164062 57.894531 286.804688 56.832031 285.417969 55.804688 C 284.035156 54.777344 282.625 53.78125 281.191406 52.824219 C 279.761719 51.867188 278.304688 50.941406 276.828125 50.054688 C 275.347656 49.167969 273.847656 48.316406 272.328125 47.503906 C 270.808594 46.6875 269.269531 45.914062 267.714844 45.175781 C 266.15625 44.4375 264.582031 43.734375 262.988281 43.074219 C 261.398438 42.414062 259.789062 41.792969 258.167969 41.210938 C 256.546875 40.625 254.910156 40.085938 253.261719 39.582031 C 251.613281 39.078125 249.953125 38.617188 248.285156 38.199219 C 246.613281 37.777344 244.933594 37.398438 243.242188 37.058594 C 241.554688 36.71875 239.859375 36.421875 238.15625 36.167969 C 236.453125 35.914062 234.742188 35.699219 233.027344 35.527344 C 231.316406 35.359375 229.597656 35.226562 227.878906 35.140625 C 226.160156 35.054688 224.4375 35.007812 222.714844 35.007812 L 222.726562 39.941406 C 224.367188 39.945312 226.007812 39.988281 227.648438 40.070312 C 229.289062 40.152344 230.921875 40.277344 232.558594 40.441406 C 234.191406 40.605469 235.816406 40.808594 237.441406 41.050781 C 239.066406 41.292969 240.683594 41.574219 242.292969 41.898438 C 243.902344 42.222656 245.503906 42.582031 247.09375 42.984375 C 248.6875 43.386719 250.269531 43.824219 251.839844 44.304688 C 253.410156 44.78125 254.96875 45.300781 256.515625 45.855469 C 258.0625 46.410156 259.59375 47 261.109375 47.632812 C 262.628906 48.261719 264.128906 48.929688 265.613281 49.632812 C 267.097656 50.335938 268.5625 51.078125 270.011719 51.851562 C 271.460938 52.628906 272.886719 53.4375 274.296875 54.285156 C 275.707031 55.128906 277.09375 56.011719 278.460938 56.921875 C 279.824219 57.835938 281.167969 58.785156 282.488281 59.761719 C 283.808594 60.742188 285.101562 61.753906 286.371094 62.796875 C 287.640625 63.839844 288.886719 64.914062 290.101562 66.015625 C 291.320312 67.121094 292.511719 68.253906 293.671875 69.414062 C 294.835938 70.578125 295.96875 71.769531 297.070312 72.984375 C 298.175781 74.203125 299.25 75.445312 300.292969 76.714844 C 301.335938 77.988281 302.34375 79.28125 303.324219 80.601562 C 304.304688 81.921875 305.25 83.261719 306.164062 84.628906 C 307.078125 85.996094 307.957031 87.382812 308.804688 88.789062 C 309.648438 90.199219 310.460938 91.628906 311.234375 93.078125 C 312.011719 94.523438 312.75 95.992188 313.457031 97.476562 C 314.160156 98.960938 314.824219 100.460938 315.457031 101.976562 C 316.085938 103.496094 316.679688 105.027344 317.234375 106.574219 C 317.789062 108.117188 318.304688 109.675781 318.785156 111.246094 C 319.261719 112.820312 319.703125 114.398438 320.105469 115.992188 C 320.503906 117.585938 320.867188 119.1875 321.191406 120.796875 C 321.511719 122.40625 321.796875 124.023438 322.039062 125.644531 C 322.28125 127.269531 322.484375 128.898438 322.648438 130.53125 C 322.8125 132.164062 322.933594 133.800781 323.015625 135.441406 C 323.101562 137.078125 323.144531 138.71875 323.144531 140.359375 C 323.148438 142 323.109375 143.640625 323.03125 145.28125 C 322.953125 146.917969 322.835938 148.554688 322.675781 150.1875 C 322.519531 151.820312 322.320312 153.449219 322.082031 155.070312 C 321.84375 156.695312 321.566406 158.308594 321.25 159.917969 C 320.929688 161.527344 320.574219 163.128906 320.179688 164.71875 C 319.78125 166.308594 319.347656 167.890625 318.875 169.460938 C 318.398438 171.03125 317.886719 172.585938 317.335938 174.132812 C 316.785156 175.675781 316.199219 177.207031 315.574219 178.71875 C 314.945312 180.234375 314.285156 181.734375 313.585938 183.214844 C 312.886719 184.699219 312.152344 186.164062 311.378906 187.609375 C 310.609375 189.054688 309.800781 190.480469 308.960938 191.886719 C 308.117188 193.292969 307.242188 194.679688 306.332031 196.042969 C 305.425781 197.40625 304.480469 198.746094 303.503906 200.0625 C 302.53125 201.378906 301.523438 202.667969 300.484375 203.9375 C 299.445312 205.203125 298.375 206.445312 297.273438 207.660156 C 296.175781 208.871094 295.046875 210.058594 293.886719 211.21875 C 292.726562 212.375 291.542969 213.503906 290.328125 214.605469 C 289.113281 215.707031 287.871094 216.773438 286.605469 217.8125 C 285.339844 218.851562 284.046875 219.859375 282.730469 220.835938 C 281.414062 221.8125 280.074219 222.753906 278.710938 223.664062 C 277.347656 224.574219 275.964844 225.449219 274.558594 226.289062 C 273.152344 227.132812 271.726562 227.9375 270.277344 228.710938 C 268.832031 229.480469 267.367188 230.214844 265.886719 230.914062 C 264.402344 231.613281 262.90625 232.277344 261.390625 232.902344 C 259.875 233.527344 258.34375 234.117188 256.800781 234.667969 C 255.257812 235.21875 253.699219 235.730469 252.128906 236.203125 C 250.558594 236.675781 248.980469 237.113281 247.390625 237.507812 C 245.796875 237.90625 244.199219 238.261719 242.589844 238.578125 C 240.980469 238.898438 239.363281 239.175781 237.742188 239.414062 C 236.117188 239.652344 234.488281 239.851562 232.855469 240.007812 C 231.222656 240.167969 229.589844 240.285156 227.949219 240.363281 C 226.308594 240.441406 224.671875 240.476562 223.03125 240.476562 L 195.191406 240.433594 L 195.203125 245.367188 L 223.042969 245.410156 C 224.761719 245.414062 226.484375 245.375 228.203125 245.292969 C 229.921875 245.210938 231.640625 245.085938 233.351562 244.921875 C 235.066406 244.753906 236.773438 244.546875 238.476562 244.296875 C 240.179688 244.046875 241.875 243.753906 243.5625 243.421875 C 245.25 243.085938 246.929688 242.714844 248.597656 242.296875 C 250.265625 241.882812 251.925781 241.425781 253.570312 240.925781 C 255.21875 240.429688 256.851562 239.894531 258.472656 239.316406 C 260.09375 238.738281 261.699219 238.121094 263.289062 237.464844 C 264.875 236.808594 266.449219 236.113281 268.003906 235.378906 C 269.558594 234.644531 271.097656 233.875 272.613281 233.0625 C 274.128906 232.253906 275.625 231.410156 277.101562 230.527344 C 278.578125 229.644531 280.03125 228.722656 281.460938 227.769531 C 282.890625 226.816406 284.296875 225.828125 285.675781 224.804688 C 287.058594 223.78125 288.414062 222.722656 289.742188 221.632812 C 291.070312 220.542969 292.375 219.421875 293.648438 218.265625 C 294.921875 217.113281 296.164062 215.925781 297.382812 214.710938 C 298.597656 213.496094 299.78125 212.25 300.9375 210.976562 C 302.089844 209.703125 303.210938 208.402344 304.300781 207.074219 C 305.394531 205.742188 306.449219 204.386719 307.472656 203.007812 C 308.496094 201.625 309.484375 200.21875 310.441406 198.789062 C 311.394531 197.359375 312.3125 195.90625 313.195312 194.433594 C 314.078125 192.957031 314.925781 191.460938 315.734375 189.945312 C 316.542969 188.425781 317.316406 186.890625 318.046875 185.335938 C 318.78125 183.78125 319.476562 182.207031 320.132812 180.617188 C 320.789062 179.027344 321.40625 177.421875 321.984375 175.804688 C 322.5625 174.183594 323.101562 172.550781 323.597656 170.902344 C 324.09375 169.257812 324.550781 167.597656 324.964844 165.929688 C 325.382812 164.257812 325.757812 162.582031 326.089844 160.890625 C 326.421875 159.203125 326.714844 157.507812 326.964844 155.804688 C 327.214844 154.105469 327.421875 152.394531 327.589844 150.683594 C 327.757812 148.96875 327.878906 147.253906 327.960938 145.535156 C 328.042969 143.816406 328.082031 142.09375 328.082031 140.371094 Z M 328.082031 140.371094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -4011.346617,
    gradientTransform: "matrix(-0.651779, -0.00099475, -0.00099475, -0.651779, -2283.292141, 2495.17102)",
    y1: 3456.665405,
    x2: -3759.074097,
    gradientUnits: "userSpaceOnUse",
    y2: 3736.967276,
    id: "id5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 97.299194%, 80.799866%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 97.299194%, 80.799866%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 97.299194%, 80.799866%)",
    offset: 0.363096
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 97.299194%, 80.799866%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 97.299194%, 80.799866%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.888367%, 97.25647%, 80.831909%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.770874%, 96.77124%, 81.213379%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.664062%, 96.328735%, 81.562805%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.557251%, 95.88623%, 81.910706%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.450439%, 95.443726%, 82.260132%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.343628%, 94.999695%, 82.608032%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.236816%, 94.55719%, 82.957458%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.128479%, 94.113159%, 83.305359%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.021667%, 93.670654%, 83.654785%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.914856%, 93.228149%, 84.002686%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.808044%, 92.785645%, 84.352112%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.699707%, 92.341614%, 84.700012%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.592896%, 91.899109%, 85.049438%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.486084%, 91.455078%, 85.397339%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.379272%, 91.012573%, 85.745239%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.270935%, 90.568542%, 86.09314%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.164124%, 90.126038%, 86.442566%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.057312%, 89.683533%, 86.790466%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.9505%, 89.241028%, 87.139893%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.843689%, 88.796997%, 87.487793%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.736877%, 88.354492%, 87.837219%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.62854%, 87.910461%, 88.18512%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.521729%, 87.467957%, 88.534546%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.414917%, 87.023926%, 88.882446%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.308105%, 86.581421%, 89.231873%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.199768%, 86.138916%, 89.579773%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.092957%, 85.696411%, 89.929199%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.986145%, 85.25238%, 90.2771%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.879333%, 84.809875%, 90.626526%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.772522%, 84.365845%, 90.974426%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.66571%, 83.92334%, 91.323853%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.557373%, 83.480835%, 91.671753%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.450562%, 83.03833%, 92.021179%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.34375%, 82.594299%, 92.36908%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.236938%, 82.151794%, 92.718506%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.128601%, 81.707764%, 93.066406%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.02179%, 81.265259%, 93.415833%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.914978%, 80.821228%, 93.763733%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.808167%, 80.378723%, 94.113159%)",
    offset: 0.617187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.699829%, 79.936218%, 94.46106%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.593018%, 79.493713%, 94.810486%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.486206%, 79.049683%, 95.158386%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.379395%, 78.607178%, 95.507812%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.272583%, 78.163147%, 95.855713%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.165771%, 77.720642%, 96.205139%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.057434%, 77.278137%, 96.55304%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.950623%, 76.835632%, 96.902466%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.843811%, 76.391602%, 97.250366%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.737%, 75.949097%, 97.599792%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.628662%, 75.505066%, 97.947693%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.521851%, 75.062561%, 98.297119%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.415039%, 74.61853%, 98.64502%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.308228%, 74.176025%, 98.994446%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.19989%, 73.733521%, 99.342346%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.0930786%, 73.291016%, 99.691772%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.0457764%, 73.094177%, 99.845886%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15 166 L 120 166 L 120 241 L 15 241 Z M 15 166 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.210938 127.847656 L 156.824219 203.460938 L 85.039062 275.242188 L 9.429688 199.632812 Z M 81.210938 127.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81.210938 127.847656 L 156.824219 203.460938 L 85.039062 275.242188 L 9.429688 199.632812 Z M 81.210938 127.847656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 64.410156 194.410156 L 119.890625 194.234375 L 119.894531 189.628906 L 64.421875 189.804688 Z M 119.8125 235.742188 L 80.875 235.863281 L 80.859375 240.472656 L 119.800781 240.347656 Z M 119.8125 224.230469 L 54.042969 224.4375 L 54.027344 229.042969 L 119.804688 228.839844 Z M 119.925781 171.179688 L 119.9375 166.574219 L 45.546875 166.808594 L 45.511719 171.398438 Z M 119.929688 178.082031 L 30.828125 178.367188 L 30.820312 182.972656 L 119.90625 182.707031 Z M 119.871094 212.671875 L 34.292969 212.957031 L 34.277344 217.554688 L 119.84375 217.292969 Z M 119.871094 201.160156 L 15.90625 201.484375 L 15.886719 206.089844 L 119.859375 205.765625 Z M 119.871094 201.160156 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -3630.405274,
    gradientTransform: "matrix(-0.607913, 0.00190095, 0.00190095, -0.607913, -2093.031245, 2165.120728)",
    y1: 3215.53,
    x2: -3458.864679,
    gradientUnits: "userSpaceOnUse",
    y2: 3215.53,
    id: "id10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.899048%, 96.899414%, 80.799866%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.175232%, 96.876526%, 80.819702%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.452942%, 96.853638%, 80.839539%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.785583%, 96.824646%, 80.863953%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.119751%, 96.79718%, 80.889893%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.452393%, 96.769714%, 80.914307%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.78656%, 96.742249%, 80.938721%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.119202%, 96.713257%, 80.963135%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.453369%, 96.685791%, 80.989075%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(8.786011%, 96.658325%, 81.013489%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.120178%, 96.630859%, 81.037903%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.45282%, 96.601868%, 81.062317%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(9.786987%, 96.574402%, 81.086731%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.119629%, 96.546936%, 81.111145%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.453796%, 96.51947%, 81.137085%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(10.786438%, 96.490479%, 81.161499%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.11908%, 96.463013%, 81.185913%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.451721%, 96.435547%, 81.210327%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(11.785889%, 96.408081%, 81.234741%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.11853%, 96.380615%, 81.259155%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.452698%, 96.353149%, 81.285095%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(12.785339%, 96.324158%, 81.309509%)",
    offset: 0.0820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.119507%, 96.296692%, 81.333923%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.452148%, 96.269226%, 81.358337%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(13.786316%, 96.24176%, 81.382751%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.118958%, 96.212769%, 81.407166%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.453125%, 96.185303%, 81.433105%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(14.785767%, 96.157837%, 81.45752%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.118408%, 96.130371%, 81.481934%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.45105%, 96.101379%, 81.506348%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(15.785217%, 96.073914%, 81.530762%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.117859%, 96.046448%, 81.555176%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.452026%, 96.018982%, 81.581116%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(16.784668%, 95.98999%, 81.60553%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.118835%, 95.962524%, 81.629944%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.451477%, 95.935059%, 81.654358%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(17.785645%, 95.907593%, 81.678772%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.118286%, 95.880127%, 81.703186%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.452454%, 95.852661%, 81.729126%)",
    offset: 0.148437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(18.785095%, 95.823669%, 81.75354%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.117737%, 95.796204%, 81.777954%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.450378%, 95.768738%, 81.802368%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(19.784546%, 95.741272%, 81.826782%)",
    offset: 0.164062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.117188%, 95.71228%, 81.851196%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.451355%, 95.684814%, 81.877136%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(20.783997%, 95.657349%, 81.90155%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.118164%, 95.629883%, 81.925964%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.450806%, 95.600891%, 81.950378%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(21.784973%, 95.573425%, 81.974792%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.117615%, 95.545959%, 81.999207%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.451782%, 95.518494%, 82.025146%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(22.784424%, 95.489502%, 82.049561%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.117065%, 95.462036%, 82.073975%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.449707%, 95.43457%, 82.098389%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(23.783875%, 95.407104%, 82.122803%)",
    offset: 0.210938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.116516%, 95.379639%, 82.147217%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.450684%, 95.352173%, 82.173157%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(24.783325%, 95.323181%, 82.197571%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.117493%, 95.295715%, 82.221985%)",
    offset: 0.226563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.450134%, 95.26825%, 82.246399%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(25.784302%, 95.240784%, 82.270813%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.116943%, 95.211792%, 82.295227%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.451111%, 95.184326%, 82.321167%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(26.783752%, 95.15686%, 82.345581%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.116394%, 95.129395%, 82.369995%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.449036%, 95.100403%, 82.394409%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(27.783203%, 95.072937%, 82.418823%)",
    offset: 0.257812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.115845%, 95.045471%, 82.443237%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.450012%, 95.018005%, 82.469177%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(28.782654%, 94.989014%, 82.493591%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.116821%, 94.961548%, 82.518005%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.449463%, 94.934082%, 82.542419%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(29.78363%, 94.906616%, 82.566833%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.116272%, 94.87915%, 82.591248%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.450439%, 94.851685%, 82.617188%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(30.783081%, 94.822693%, 82.641602%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.115723%, 94.795227%, 82.666016%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.448364%, 94.767761%, 82.69043%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(31.782532%, 94.740295%, 82.714844%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.115173%, 94.711304%, 82.739258%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.449341%, 94.683838%, 82.765198%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(32.781982%, 94.656372%, 82.789612%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.11615%, 94.628906%, 82.814026%)",
    offset: 0.320313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.448792%, 94.599915%, 82.83844%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(33.782959%, 94.572449%, 82.862854%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.115601%, 94.544983%, 82.887268%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.449768%, 94.517517%, 82.913208%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.78241%, 94.488525%, 82.937622%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.115051%, 94.46106%, 82.962036%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.447693%, 94.433594%, 82.98645%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.78186%, 94.406128%, 83.010864%)",
    offset: 0.351563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.114502%, 94.378662%, 83.035278%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.448669%, 94.351196%, 83.061218%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.781311%, 94.322205%, 83.085632%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.115479%, 94.294739%, 83.110046%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.44812%, 94.267273%, 83.13446%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.782288%, 94.239807%, 83.158875%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.114929%, 94.210815%, 83.183289%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.449097%, 94.18335%, 83.209229%)",
    offset: 0.382813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.781738%, 94.155884%, 83.233643%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.11438%, 94.128418%, 83.258057%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.447021%, 94.099426%, 83.282471%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.781189%, 94.07196%, 83.306885%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.113831%, 94.044495%, 83.331299%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.447998%, 94.017029%, 83.357239%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.78064%, 93.988037%, 83.381653%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.114807%, 93.960571%, 83.406067%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.447449%, 93.933105%, 83.430481%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.781616%, 93.90564%, 83.454895%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.114258%, 93.878174%, 83.479309%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.448425%, 93.850708%, 83.505249%)",
    offset: 0.429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.781067%, 93.821716%, 83.529663%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.113708%, 93.79425%, 83.554077%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.44635%, 93.766785%, 83.578491%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.780518%, 93.739319%, 83.602905%)",
    offset: 0.445313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.113159%, 93.710327%, 83.627319%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.447327%, 93.682861%, 83.653259%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.779968%, 93.655396%, 83.677673%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.114136%, 93.62793%, 83.702087%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.446777%, 93.598938%, 83.726501%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.780945%, 93.571472%, 83.750916%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.113586%, 93.544006%, 83.77533%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.447754%, 93.516541%, 83.80127%)",
    offset: 0.476563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.780396%, 93.487549%, 83.825684%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.113037%, 93.460083%, 83.850098%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.445679%, 93.432617%, 83.874512%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.779846%, 93.405151%, 83.900452%)",
    offset: 0.492188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.112488%, 93.37616%, 83.924866%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.446655%, 93.348694%, 83.94928%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.779297%, 93.321228%, 83.973694%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.113464%, 93.293762%, 83.998108%)",
    offset: 0.507813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.446106%, 93.266296%, 84.022522%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.780273%, 93.238831%, 84.048462%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.112915%, 93.209839%, 84.072876%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.447083%, 93.182373%, 84.09729%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.779724%, 93.154907%, 84.121704%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.112366%, 93.127441%, 84.146118%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.445007%, 93.09845%, 84.170532%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.779175%, 93.070984%, 84.196472%)",
    offset: 0.539063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.111816%, 93.043518%, 84.220886%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.445984%, 93.016052%, 84.2453%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.778625%, 92.987061%, 84.269714%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.112793%, 92.959595%, 84.294128%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.445435%, 92.932129%, 84.318542%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.779602%, 92.904663%, 84.344482%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.112244%, 92.875671%, 84.368896%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.446411%, 92.848206%, 84.393311%)",
    offset: 0.570313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.779053%, 92.82074%, 84.417725%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.111694%, 92.793274%, 84.442139%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.444336%, 92.765808%, 84.466553%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.778503%, 92.738342%, 84.492493%)",
    offset: 0.585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.111145%, 92.709351%, 84.516907%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.445312%, 92.681885%, 84.541321%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.777954%, 92.654419%, 84.565735%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.112122%, 92.626953%, 84.590149%)",
    offset: 0.601563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.444763%, 92.597961%, 84.614563%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.778931%, 92.570496%, 84.640503%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.111572%, 92.54303%, 84.664917%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.44574%, 92.515564%, 84.689331%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.778381%, 92.486572%, 84.713745%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.111023%, 92.459106%, 84.738159%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.443665%, 92.431641%, 84.762573%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.777832%, 92.404175%, 84.788513%)",
    offset: 0.632813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.110474%, 92.375183%, 84.812927%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.444641%, 92.347717%, 84.837341%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(60.777283%, 92.320251%, 84.861755%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.11145%, 92.292786%, 84.886169%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.444092%, 92.26532%, 84.910583%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(61.778259%, 92.237854%, 84.936523%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.110901%, 92.208862%, 84.960938%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.445068%, 92.181396%, 84.985352%)",
    offset: 0.664063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(62.77771%, 92.153931%, 85.009766%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.110352%, 92.126465%, 85.03418%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.442993%, 92.097473%, 85.058594%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(63.777161%, 92.070007%, 85.084534%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.109802%, 92.042542%, 85.108948%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.44397%, 92.015076%, 85.133362%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(64.776611%, 91.986084%, 85.157776%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.110779%, 91.958618%, 85.18219%)",
    offset: 0.695313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.44342%, 91.931152%, 85.206604%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(65.777588%, 91.903687%, 85.232544%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.110229%, 91.874695%, 85.256958%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.444397%, 91.847229%, 85.281372%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(66.777039%, 91.819763%, 85.305786%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.10968%, 91.792297%, 85.3302%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.442322%, 91.764832%, 85.354614%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(67.776489%, 91.737366%, 85.380554%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.109131%, 91.708374%, 85.404968%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.443298%, 91.680908%, 85.429382%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(68.77594%, 91.653442%, 85.453796%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.110107%, 91.625977%, 85.47821%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.442749%, 91.596985%, 85.502625%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(69.776917%, 91.569519%, 85.528564%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.109558%, 91.542053%, 85.552979%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.443726%, 91.514587%, 85.577393%)",
    offset: 0.757812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(70.776367%, 91.485596%, 85.601807%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.109009%, 91.45813%, 85.626221%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.44165%, 91.430664%, 85.650635%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(71.775818%, 91.403198%, 85.676575%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.108459%, 91.374207%, 85.700989%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.442627%, 91.346741%, 85.725403%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(72.775269%, 91.319275%, 85.749817%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.109436%, 91.291809%, 85.774231%)",
    offset: 0.789062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.442078%, 91.264343%, 85.798645%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(73.776245%, 91.236877%, 85.824585%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.108887%, 91.207886%, 85.848999%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.443054%, 91.18042%, 85.873413%)",
    offset: 0.804687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(74.775696%, 91.152954%, 85.897827%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.108337%, 91.125488%, 85.922241%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.440979%, 91.096497%, 85.946655%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(75.775146%, 91.069031%, 85.972595%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.107788%, 91.041565%, 85.997009%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.441956%, 91.014099%, 86.021423%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(76.774597%, 90.985107%, 86.045837%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.108765%, 90.957642%, 86.070251%)",
    offset: 0.835937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.441406%, 90.930176%, 86.094666%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(77.775574%, 90.90271%, 86.120605%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.108215%, 90.873718%, 86.14502%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.442383%, 90.846252%, 86.169434%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(78.775024%, 90.818787%, 86.193848%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.107666%, 90.791321%, 86.218262%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.440308%, 90.763855%, 86.242676%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(79.774475%, 90.736389%, 86.268616%)",
    offset: 0.867187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.107117%, 90.707397%, 86.29303%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.441284%, 90.679932%, 86.317444%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(80.773926%, 90.652466%, 86.341858%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.108093%, 90.625%, 86.366272%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.440735%, 90.596008%, 86.390686%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(81.774902%, 90.568542%, 86.416626%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.107544%, 90.541077%, 86.44104%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.441711%, 90.513611%, 86.465454%)",
    offset: 0.898437
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(82.774353%, 90.484619%, 86.489868%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.106995%, 90.457153%, 86.514282%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.439636%, 90.429688%, 86.538696%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(83.773804%, 90.402222%, 86.564636%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.106445%, 90.37323%, 86.58905%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.440613%, 90.345764%, 86.613464%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(84.773254%, 90.318298%, 86.637878%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.107422%, 90.290833%, 86.663818%)",
    offset: 0.929687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.440063%, 90.263367%, 86.688232%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(85.774231%, 90.235901%, 86.712646%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.106873%, 90.206909%, 86.737061%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.44104%, 90.179443%, 86.761475%)",
    offset: 0.945312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(86.773682%, 90.151978%, 86.785889%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.106323%, 90.124512%, 86.811829%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.438965%, 90.09552%, 86.836243%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(87.773132%, 90.068054%, 86.860657%)",
    offset: 0.960937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.105774%, 90.040588%, 86.885071%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.439941%, 90.013123%, 86.909485%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(88.772583%, 89.984131%, 86.933899%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.10675%, 89.956665%, 86.959839%)",
    offset: 0.976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.439392%, 89.929199%, 86.984253%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(89.77356%, 89.901733%, 87.008667%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.106201%, 89.872742%, 87.033081%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.440369%, 89.845276%, 87.057495%)",
    offset: 0.992187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.719604%, 89.822388%, 87.077332%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(90.99884%, 89.7995%, 87.098694%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 117 34 L 224 34 L 224 366 L 117 366 Z M 117 34 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.234375 12.984375 L 375.425781 187.175781 L 197.40625 365.195312 L 23.214844 191.003906 Z M 201.234375 12.984375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.234375 12.984375 L 375.425781 187.175781 L 197.40625 365.195312 L 23.214844 191.003906 Z M 201.234375 12.984375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "id14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 223.277344 101.980469 L 223.273438 97.019531 C 221.847656 97.019531 220.421875 97.089844 219.003906 97.230469 C 217.585938 97.367188 216.175781 97.578125 214.777344 97.855469 C 213.378906 98.132812 211.996094 98.480469 210.632812 98.894531 C 209.265625 99.308594 207.925781 99.789062 206.609375 100.332031 C 205.292969 100.878906 204.003906 101.488281 202.746094 102.160156 C 201.488281 102.832031 200.269531 103.5625 199.082031 104.355469 C 197.898438 105.148438 196.753906 105.996094 195.652344 106.898438 C 194.550781 107.804688 193.496094 108.761719 192.488281 109.769531 C 191.480469 110.777344 190.523438 111.832031 189.617188 112.933594 C 188.714844 114.035156 187.867188 115.179688 187.074219 116.363281 C 186.28125 117.550781 185.550781 118.769531 184.878906 120.027344 C 184.207031 121.285156 183.597656 122.574219 183.050781 123.890625 C 182.507812 125.207031 182.027344 126.546875 181.613281 127.914062 C 181.199219 129.277344 180.851562 130.660156 180.574219 132.058594 C 180.296875 133.457031 180.085938 134.867188 179.949219 136.285156 C 179.808594 137.703125 179.738281 139.128906 179.738281 140.554688 L 179.933594 347.722656 L 184.898438 352.6875 L 184.699219 140.558594 C 184.699219 139.296875 184.761719 138.035156 184.882812 136.777344 C 185.007812 135.519531 185.191406 134.269531 185.4375 133.027344 C 185.6875 131.789062 185.992188 130.566406 186.359375 129.355469 C 186.726562 128.144531 187.152344 126.957031 187.632812 125.789062 C 188.117188 124.621094 188.65625 123.480469 189.253906 122.367188 C 189.847656 121.253906 190.496094 120.171875 191.199219 119.121094 C 191.898438 118.070312 192.652344 117.058594 193.453125 116.082031 C 194.253906 115.105469 195.101562 114.167969 195.996094 113.277344 C 196.886719 112.382812 197.824219 111.535156 198.800781 110.734375 C 199.777344 109.933594 200.789062 109.179688 201.839844 108.480469 C 202.890625 107.777344 203.972656 107.128906 205.085938 106.535156 C 206.199219 105.9375 207.339844 105.398438 208.507812 104.914062 C 209.675781 104.433594 210.863281 104.007812 212.074219 103.640625 C 213.285156 103.273438 214.507812 102.96875 215.746094 102.71875 C 216.988281 102.472656 218.238281 102.289062 219.496094 102.164062 C 220.753906 102.042969 222.015625 101.980469 223.277344 101.980469 Z M 197.128906 140.554688 C 197.128906 139.695312 197.167969 138.839844 197.253906 137.984375 C 197.339844 137.132812 197.464844 136.285156 197.632812 135.441406 C 197.796875 134.601562 198.007812 133.769531 198.253906 132.949219 C 198.503906 132.128906 198.792969 131.324219 199.121094 130.53125 C 199.449219 129.738281 199.816406 128.964844 200.21875 128.207031 C 200.625 127.453125 201.0625 126.71875 201.539062 126.003906 C 202.015625 125.292969 202.527344 124.605469 203.070312 123.941406 C 203.613281 123.277344 204.1875 122.644531 204.792969 122.039062 C 205.402344 121.433594 206.035156 120.859375 206.699219 120.3125 C 207.359375 119.769531 208.046875 119.261719 208.761719 118.785156 C 209.472656 118.308594 210.207031 117.867188 210.964844 117.464844 C 211.71875 117.058594 212.496094 116.691406 213.285156 116.363281 C 214.078125 116.035156 214.886719 115.75 215.707031 115.5 C 216.527344 115.25 217.359375 115.042969 218.199219 114.875 C 219.039062 114.707031 219.886719 114.582031 220.742188 114.5 C 221.59375 114.414062 222.449219 114.371094 223.308594 114.371094 L 223.304688 109.410156 C 222.285156 109.410156 221.265625 109.460938 220.25 109.5625 C 219.234375 109.664062 218.226562 109.8125 217.226562 110.011719 C 216.226562 110.210938 215.238281 110.457031 214.261719 110.753906 C 213.285156 111.050781 212.328125 111.394531 211.386719 111.785156 C 210.445312 112.175781 209.523438 112.609375 208.625 113.089844 C 207.726562 113.570312 206.851562 114.09375 206.003906 114.660156 C 205.15625 115.226562 204.339844 115.832031 203.550781 116.480469 C 202.761719 117.125 202.007812 117.808594 201.285156 118.53125 C 200.566406 119.253906 199.882812 120.007812 199.234375 120.792969 C 198.589844 121.582031 197.984375 122.398438 197.417969 123.246094 C 196.851562 124.09375 196.328125 124.96875 195.84375 125.867188 C 195.363281 126.765625 194.929688 127.6875 194.539062 128.628906 C 194.148438 129.570312 193.804688 130.53125 193.511719 131.507812 C 193.214844 132.484375 192.964844 133.472656 192.765625 134.472656 C 192.566406 135.472656 192.417969 136.480469 192.316406 137.496094 C 192.21875 138.511719 192.167969 139.527344 192.167969 140.546875 L 192.367188 360.15625 L 197.324219 365.113281 Z M 187.199219 104.476562 C 189.5625 102.101562 192.132812 99.984375 194.914062 98.121094 C 197.699219 96.257812 200.636719 94.683594 203.730469 93.40625 C 206.828125 92.125 210.019531 91.164062 213.308594 90.515625 C 216.59375 89.871094 219.914062 89.554688 223.265625 89.566406 L 223.261719 84.605469 C 221.429688 84.605469 219.597656 84.695312 217.773438 84.871094 C 215.949219 85.050781 214.136719 85.316406 212.339844 85.671875 C 210.542969 86.03125 208.765625 86.472656 207.011719 87.003906 C 205.257812 87.535156 203.53125 88.148438 201.839844 88.851562 C 200.144531 89.550781 198.492188 90.332031 196.875 91.195312 C 195.257812 92.058594 193.6875 93 192.164062 94.015625 C 190.640625 95.035156 189.167969 96.125 187.753906 97.285156 C 186.335938 98.445312 184.980469 99.675781 183.6875 100.972656 C 182.390625 102.265625 181.160156 103.621094 180 105.039062 C 178.835938 106.457031 177.746094 107.925781 176.730469 109.449219 C 175.710938 110.972656 174.773438 112.542969 173.910156 114.160156 C 173.046875 115.777344 172.265625 117.429688 171.566406 119.125 C 170.863281 120.816406 170.25 122.542969 169.71875 124.296875 C 169.1875 126.050781 168.742188 127.828125 168.386719 129.625 C 168.03125 131.421875 167.765625 133.234375 167.585938 135.058594 C 167.40625 136.882812 167.320312 138.714844 167.320312 140.546875 L 167.511719 335.300781 L 172.476562 340.265625 L 172.285156 140.546875 C 172.273438 137.195312 172.589844 133.875 173.238281 130.585938 C 173.882812 127.300781 174.847656 124.105469 176.125 121.011719 C 177.40625 117.914062 178.976562 114.976562 180.839844 112.191406 C 182.707031 109.410156 184.824219 106.835938 187.199219 104.476562 Z M 152.0625 69.335938 C 154.382812 67 156.816406 64.785156 159.363281 62.691406 C 161.90625 60.59375 164.546875 58.632812 167.285156 56.796875 C 170.023438 54.964844 172.84375 53.269531 175.75 51.71875 C 178.65625 50.164062 181.632812 48.757812 184.679688 47.496094 C 187.726562 46.238281 190.828125 45.132812 193.984375 44.179688 C 197.140625 43.226562 200.335938 42.433594 203.570312 41.796875 C 206.804688 41.164062 210.066406 40.6875 213.347656 40.375 C 216.628906 40.0625 219.921875 39.910156 223.21875 39.921875 L 223.21875 34.964844 C 221.492188 34.964844 219.761719 35.003906 218.035156 35.089844 C 216.308594 35.171875 214.585938 35.296875 212.867188 35.464844 C 211.144531 35.632812 209.429688 35.84375 207.71875 36.09375 C 206.011719 36.347656 204.308594 36.640625 202.613281 36.976562 C 200.917969 37.3125 199.230469 37.6875 197.554688 38.105469 C 195.878906 38.523438 194.210938 38.984375 192.558594 39.484375 C 190.90625 39.984375 189.265625 40.523438 187.636719 41.105469 C 186.007812 41.6875 184.398438 42.308594 182.800781 42.96875 C 181.203125 43.628906 179.625 44.324219 178.0625 45.0625 C 176.5 45.800781 174.957031 46.578125 173.433594 47.390625 C 171.910156 48.203125 170.40625 49.054688 168.925781 49.941406 C 167.441406 50.828125 165.984375 51.753906 164.546875 52.710938 C 163.109375 53.671875 161.699219 54.664062 160.3125 55.691406 C 158.921875 56.722656 157.5625 57.78125 156.226562 58.878906 C 154.890625 59.972656 153.582031 61.101562 152.304688 62.261719 C 151.023438 63.421875 149.773438 64.613281 148.550781 65.832031 C 147.332031 67.054688 146.140625 68.304688 144.980469 69.585938 C 143.820312 70.863281 142.691406 72.171875 141.597656 73.507812 C 140.5 74.84375 139.441406 76.203125 138.410156 77.59375 C 137.382812 78.980469 136.390625 80.390625 135.429688 81.828125 C 134.472656 83.265625 133.546875 84.722656 132.660156 86.207031 C 131.773438 87.6875 130.921875 89.191406 130.109375 90.714844 C 129.296875 92.238281 128.519531 93.78125 127.78125 95.34375 C 127.042969 96.90625 126.347656 98.484375 125.6875 100.082031 C 125.027344 101.679688 124.40625 103.289062 123.824219 104.917969 C 123.242188 106.546875 122.703125 108.1875 122.203125 109.839844 C 121.703125 111.492188 121.242188 113.160156 120.824219 114.835938 C 120.40625 116.511719 120.03125 118.199219 119.695312 119.894531 C 119.359375 121.589844 119.066406 123.292969 118.8125 125 C 118.5625 126.710938 118.351562 128.425781 118.183594 130.148438 C 118.015625 131.867188 117.890625 133.589844 117.808594 135.316406 C 117.722656 137.042969 117.683594 138.769531 117.683594 140.5 L 117.824219 285.613281 L 122.785156 290.574219 L 122.640625 140.5 C 122.628906 137.203125 122.78125 133.910156 123.09375 130.628906 C 123.40625 127.34375 123.882812 124.085938 124.519531 120.851562 C 125.15625 117.613281 125.949219 114.417969 126.902344 111.261719 C 127.851562 108.105469 128.960938 105.003906 130.21875 101.957031 C 131.476562 98.914062 132.882812 95.9375 134.4375 93.03125 C 135.992188 90.121094 137.6875 87.300781 139.519531 84.5625 C 141.355469 81.824219 143.316406 79.183594 145.414062 76.640625 C 147.507812 74.09375 149.722656 71.660156 152.0625 69.335938 Z M 160.863281 78.136719 C 162.898438 76.089844 165.03125 74.148438 167.257812 72.308594 C 169.484375 70.472656 171.800781 68.75 174.199219 67.140625 C 176.597656 65.53125 179.070312 64.046875 181.617188 62.683594 C 184.164062 61.320312 186.769531 60.085938 189.441406 58.980469 C 192.109375 57.875 194.824219 56.902344 197.589844 56.066406 C 200.355469 55.230469 203.15625 54.53125 205.992188 53.972656 C 208.828125 53.414062 211.683594 52.996094 214.5625 52.71875 C 217.4375 52.441406 220.320312 52.308594 223.210938 52.316406 L 223.210938 47.359375 C 221.6875 47.359375 220.160156 47.394531 218.636719 47.46875 C 217.113281 47.539062 215.59375 47.652344 214.074219 47.796875 C 212.558594 47.945312 211.042969 48.132812 209.535156 48.355469 C 208.023438 48.578125 206.523438 48.835938 205.027344 49.132812 C 203.53125 49.425781 202.042969 49.761719 200.5625 50.128906 C 199.082031 50.5 197.613281 50.902344 196.152344 51.34375 C 194.695312 51.785156 193.246094 52.265625 191.808594 52.777344 C 190.375 53.289062 188.953125 53.835938 187.542969 54.417969 C 186.132812 55 184.738281 55.617188 183.359375 56.269531 C 181.980469 56.917969 180.621094 57.605469 179.277344 58.320312 C 177.929688 59.039062 176.605469 59.789062 175.296875 60.574219 C 173.988281 61.355469 172.699219 62.171875 171.433594 63.019531 C 170.164062 63.863281 168.917969 64.742188 167.695312 65.648438 C 166.46875 66.554688 165.269531 67.492188 164.089844 68.460938 C 162.910156 69.425781 161.757812 70.421875 160.628906 71.445312 C 159.496094 72.46875 158.394531 73.519531 157.316406 74.597656 C 156.238281 75.675781 155.1875 76.777344 154.164062 77.910156 C 153.140625 79.039062 152.144531 80.191406 151.179688 81.371094 C 150.210938 82.550781 149.273438 83.75 148.367188 84.976562 C 147.460938 86.199219 146.582031 87.445312 145.738281 88.714844 C 144.890625 89.980469 144.074219 91.269531 143.292969 92.578125 C 142.507812 93.886719 141.757812 95.210938 141.039062 96.558594 C 140.324219 97.902344 139.636719 99.261719 138.988281 100.640625 C 138.335938 102.019531 137.71875 103.414062 137.136719 104.824219 C 136.554688 106.234375 136.007812 107.65625 135.496094 109.089844 C 134.984375 110.527344 134.503906 111.976562 134.0625 113.433594 C 133.621094 114.894531 133.21875 116.363281 132.847656 117.84375 C 132.480469 119.324219 132.144531 120.8125 131.851562 122.308594 C 131.554688 123.804688 131.296875 125.304688 131.074219 126.816406 C 130.851562 128.324219 130.664062 129.839844 130.515625 131.355469 C 130.371094 132.875 130.257812 134.394531 130.1875 135.917969 C 130.113281 137.441406 130.078125 138.96875 130.078125 140.492188 L 130.226562 298.015625 L 135.207031 302.996094 L 135.035156 140.492188 C 135.023438 137.601562 135.160156 134.71875 135.433594 131.839844 C 135.710938 128.960938 136.128906 126.105469 136.6875 123.269531 C 137.246094 120.433594 137.941406 117.632812 138.777344 114.867188 C 139.613281 112.101562 140.585938 109.382812 141.691406 106.710938 C 142.796875 104.042969 144.03125 101.433594 145.394531 98.886719 C 146.757812 96.339844 148.242188 93.867188 149.851562 91.464844 C 151.457031 89.066406 153.179688 86.75 155.019531 84.523438 C 156.855469 82.292969 158.800781 80.160156 160.847656 78.125 Z M 169.664062 86.9375 C 171.414062 85.179688 173.25 83.511719 175.167969 81.933594 C 177.085938 80.355469 179.074219 78.875 181.140625 77.492188 C 183.203125 76.113281 185.332031 74.839844 187.523438 73.667969 C 189.710938 72.5 191.957031 71.4375 194.253906 70.492188 C 196.546875 69.542969 198.886719 68.710938 201.265625 67.996094 C 203.644531 67.28125 206.050781 66.683594 208.488281 66.203125 C 210.929688 65.726562 213.386719 65.371094 215.859375 65.136719 C 218.332031 64.902344 220.8125 64.789062 223.296875 64.800781 L 223.242188 59.789062 C 221.921875 59.789062 220.597656 59.820312 219.277344 59.882812 C 217.957031 59.945312 216.636719 60.042969 215.320312 60.171875 C 214.003906 60.296875 212.695312 60.457031 211.386719 60.652344 C 210.078125 60.84375 208.773438 61.070312 207.476562 61.324219 C 206.179688 61.582031 204.890625 61.871094 203.609375 62.191406 C 202.324219 62.511719 201.050781 62.863281 199.785156 63.246094 C 198.519531 63.628906 197.265625 64.039062 196.023438 64.484375 C 194.777344 64.929688 193.542969 65.402344 192.320312 65.910156 C 191.101562 66.414062 189.890625 66.949219 188.695312 67.511719 C 187.503906 68.078125 186.320312 68.671875 185.15625 69.292969 C 183.988281 69.914062 182.839844 70.566406 181.707031 71.246094 C 180.574219 71.921875 179.457031 72.628906 178.355469 73.363281 C 177.257812 74.097656 176.179688 74.855469 175.117188 75.644531 C 174.054688 76.429688 173.011719 77.242188 171.992188 78.082031 C 170.96875 78.917969 169.96875 79.78125 168.992188 80.667969 C 168.011719 81.554688 167.054688 82.46875 166.121094 83.402344 C 165.1875 84.335938 164.273438 85.292969 163.386719 86.273438 C 162.5 87.25 161.636719 88.25 160.800781 89.273438 C 159.960938 90.292969 159.148438 91.335938 158.363281 92.398438 C 157.574219 93.460938 156.816406 94.539062 156.082031 95.636719 C 155.347656 96.738281 154.640625 97.855469 153.964844 98.988281 C 153.285156 100.121094 152.632812 101.269531 152.011719 102.4375 C 151.390625 103.601562 150.796875 104.785156 150.230469 105.976562 C 149.667969 107.171875 149.132812 108.382812 148.628906 109.601562 C 148.121094 110.824219 147.648438 112.058594 147.203125 113.300781 C 146.757812 114.546875 146.347656 115.800781 145.964844 117.066406 C 145.582031 118.332031 145.230469 119.605469 144.910156 120.890625 C 144.589844 122.171875 144.300781 123.460938 144.042969 124.757812 C 143.789062 126.054688 143.5625 127.359375 143.371094 128.667969 C 143.175781 129.976562 143.015625 131.285156 142.890625 132.601562 C 142.761719 133.917969 142.664062 135.238281 142.601562 136.558594 C 142.539062 137.878906 142.507812 139.203125 142.507812 140.523438 L 142.664062 310.453125 L 147.632812 315.417969 L 147.464844 140.496094 C 147.457031 138.011719 147.570312 135.535156 147.808594 133.0625 C 148.042969 130.589844 148.402344 128.136719 148.882812 125.699219 C 149.363281 123.261719 149.960938 120.855469 150.679688 118.476562 C 151.394531 116.101562 152.230469 113.765625 153.179688 111.472656 C 154.125 109.179688 155.1875 106.9375 156.355469 104.75 C 157.527344 102.558594 158.804688 100.433594 160.183594 98.371094 C 161.566406 96.308594 163.046875 94.320312 164.625 92.40625 C 166.203125 90.488281 167.871094 88.65625 169.628906 86.90625 Z M 223.253906 77.15625 L 223.25 72.195312 C 222.132812 72.195312 221.011719 72.222656 219.894531 72.28125 C 218.777344 72.335938 217.664062 72.417969 216.550781 72.527344 C 215.4375 72.636719 214.328125 72.773438 213.222656 72.9375 C 212.117188 73.105469 211.015625 73.292969 209.917969 73.511719 C 208.820312 73.730469 207.730469 73.976562 206.644531 74.25 C 205.5625 74.519531 204.484375 74.820312 203.414062 75.144531 C 202.34375 75.46875 201.28125 75.820312 200.230469 76.195312 C 199.175781 76.574219 198.132812 76.972656 197.101562 77.402344 C 196.070312 77.832031 195.046875 78.285156 194.035156 78.761719 C 193.027344 79.238281 192.027344 79.742188 191.042969 80.269531 C 190.054688 80.796875 189.085938 81.347656 188.125 81.921875 C 187.167969 82.496094 186.222656 83.09375 185.292969 83.714844 C 184.363281 84.335938 183.449219 84.980469 182.550781 85.644531 C 181.65625 86.308594 180.773438 86.996094 179.910156 87.707031 C 179.046875 88.414062 178.199219 89.144531 177.371094 89.894531 C 176.542969 90.648438 175.734375 91.417969 174.945312 92.207031 C 174.152344 92.996094 173.382812 93.808594 172.632812 94.632812 C 171.882812 95.460938 171.152344 96.308594 170.445312 97.171875 C 169.734375 98.035156 169.046875 98.917969 168.382812 99.816406 C 167.714844 100.714844 167.074219 101.625 166.453125 102.554688 C 165.832031 103.484375 165.234375 104.429688 164.65625 105.386719 C 164.082031 106.347656 163.53125 107.320312 163.003906 108.304688 C 162.480469 109.289062 161.976562 110.289062 161.5 111.300781 C 161.019531 112.308594 160.566406 113.332031 160.140625 114.363281 C 159.710938 115.398438 159.308594 116.441406 158.933594 117.492188 C 158.554688 118.546875 158.207031 119.605469 157.878906 120.675781 C 157.554688 121.746094 157.257812 122.824219 156.984375 123.90625 C 156.714844 124.992188 156.46875 126.082031 156.25 127.179688 C 156.03125 128.277344 155.839844 129.378906 155.675781 130.484375 C 155.511719 131.589844 155.375 132.699219 155.265625 133.8125 C 155.15625 134.925781 155.070312 136.042969 155.015625 137.160156 C 154.960938 138.277344 154.933594 139.394531 154.933594 140.511719 L 155.105469 322.839844 L 160.074219 327.804688 L 159.875 140.535156 C 159.875 138.457031 159.976562 136.386719 160.179688 134.320312 C 160.382812 132.253906 160.683594 130.199219 161.089844 128.164062 C 161.492188 126.125 161.996094 124.113281 162.597656 122.128906 C 163.199219 120.140625 163.898438 118.1875 164.691406 116.269531 C 165.484375 114.351562 166.371094 112.476562 167.351562 110.644531 C 168.328125 108.816406 169.394531 107.035156 170.546875 105.308594 C 171.699219 103.585938 172.933594 101.917969 174.25 100.316406 C 175.566406 98.710938 176.957031 97.175781 178.425781 95.707031 C 179.894531 94.238281 181.429688 92.847656 183.035156 91.53125 C 184.636719 90.214844 186.304688 88.980469 188.03125 87.828125 C 189.753906 86.675781 191.535156 85.609375 193.363281 84.632812 C 195.195312 83.652344 197.070312 82.765625 198.988281 81.972656 C 200.90625 81.179688 202.859375 80.480469 204.847656 79.878906 C 206.832031 79.277344 208.84375 78.773438 210.882812 78.371094 C 212.917969 77.964844 214.972656 77.664062 217.039062 77.460938 C 219.105469 77.257812 221.175781 77.15625 223.253906 77.15625 Z M 223.253906 77.15625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -50.406943,
    gradientTransform: "matrix(0.463201, 0.463201, -0.462319, 0.462319, 201.31891, 13.06659)",
    y1: -13.438577,
    x2: 370.356085,
    gradientUnits: "userSpaceOnUse",
    y2: 498.629778,
    id: "id15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0%, 72.898865%, 100%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.0427246%, 72.488403%, 100%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.0869751%, 72.077942%, 100%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.161743%, 71.376038%, 100%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.236511%, 70.674133%, 100%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.311279%, 69.972229%, 100%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.387573%, 69.271851%, 100%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.462341%, 68.569946%, 100%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.537109%, 67.869568%, 100%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.611877%, 67.167664%, 100%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.688171%, 66.465759%, 100%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.762939%, 65.763855%, 100%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.837708%, 65.063477%, 100%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.912476%, 64.361572%, 100%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(0.987244%, 63.661194%, 100%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.062012%, 62.95929%, 100%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.138306%, 62.257385%, 100%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.213074%, 61.555481%, 100%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.287842%, 60.855103%, 100%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.36261%, 60.153198%, 100%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.437378%, 59.45282%, 100%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.512146%, 58.750916%, 100%)",
    offset: 0.402344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.58844%, 58.049011%, 100%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.663208%, 57.347107%, 100%)",
    offset: 0.410156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.737976%, 56.646729%, 100%)",
    offset: 0.414062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.812744%, 55.944824%, 100%)",
    offset: 0.417969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.889038%, 55.244446%, 100%)",
    offset: 0.421875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(1.963806%, 54.542542%, 100%)",
    offset: 0.425781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.038574%, 53.840637%, 100%)",
    offset: 0.429687
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.113342%, 53.138733%, 100%)",
    offset: 0.433594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.18811%, 52.438354%, 100%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.262878%, 51.73645%, 100%)",
    offset: 0.441406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.339172%, 51.036072%, 100%)",
    offset: 0.445312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.41394%, 50.334167%, 100%)",
    offset: 0.449219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.488708%, 49.632263%, 100%)",
    offset: 0.453125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.563477%, 48.930359%, 100%)",
    offset: 0.457031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.638245%, 48.22998%, 100%)",
    offset: 0.460938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.713013%, 47.528076%, 100%)",
    offset: 0.464844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.789307%, 46.827698%, 100%)",
    offset: 0.46875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.864075%, 46.125793%, 100%)",
    offset: 0.472656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(2.938843%, 45.423889%, 100%)",
    offset: 0.476562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.013611%, 44.721985%, 100%)",
    offset: 0.480469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.088379%, 44.021606%, 100%)",
    offset: 0.484375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.163147%, 43.319702%, 100%)",
    offset: 0.488281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.239441%, 42.619324%, 100%)",
    offset: 0.492187
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.314209%, 41.917419%, 100%)",
    offset: 0.496094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.388977%, 41.215515%, 100%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.463745%, 40.513611%, 100%)",
    offset: 0.503906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.540039%, 39.813232%, 100%)",
    offset: 0.507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.614807%, 39.111328%, 100%)",
    offset: 0.511719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.689575%, 38.41095%, 100%)",
    offset: 0.515625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.764343%, 37.709045%, 100%)",
    offset: 0.519531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.839111%, 37.007141%, 100%)",
    offset: 0.523438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.913879%, 36.305237%, 100%)",
    offset: 0.527344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(3.990173%, 35.604858%, 100%)",
    offset: 0.53125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.064941%, 34.902954%, 100%)",
    offset: 0.535156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.139709%, 34.202576%, 100%)",
    offset: 0.539062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.214478%, 33.500671%, 100%)",
    offset: 0.542969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.289246%, 32.798767%, 100%)",
    offset: 0.546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.364014%, 32.096863%, 100%)",
    offset: 0.550781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.440308%, 31.396484%, 100%)",
    offset: 0.554688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.515076%, 30.69458%, 100%)",
    offset: 0.558594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.589844%, 29.994202%, 100%)",
    offset: 0.5625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.664612%, 29.292297%, 100%)",
    offset: 0.566406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.73938%, 28.590393%, 100%)",
    offset: 0.570312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.814148%, 27.888489%, 100%)",
    offset: 0.574219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.890442%, 27.18811%, 100%)",
    offset: 0.578125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(4.96521%, 26.486206%, 100%)",
    offset: 0.582031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.039978%, 25.785828%, 100%)",
    offset: 0.585937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.114746%, 25.083923%, 100%)",
    offset: 0.589844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.19104%, 24.382019%, 100%)",
    offset: 0.59375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.265808%, 23.680115%, 100%)",
    offset: 0.597656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.340576%, 22.979736%, 100%)",
    offset: 0.601562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.415344%, 22.277832%, 100%)",
    offset: 0.605469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.490112%, 21.577454%, 100%)",
    offset: 0.609375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.56488%, 20.875549%, 100%)",
    offset: 0.613281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.641174%, 20.173645%, 100%)",
    offset: 0.617188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.715942%, 19.471741%, 100%)",
    offset: 0.621094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.79071%, 18.771362%, 100%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.865479%, 18.069458%, 100%)",
    offset: 0.628906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(5.940247%, 17.36908%, 100%)",
    offset: 0.632812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.015015%, 16.667175%, 100%)",
    offset: 0.636719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.091309%, 15.965271%, 100%)",
    offset: 0.640625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.166077%, 15.263367%, 100%)",
    offset: 0.644531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.240845%, 14.562988%, 100%)",
    offset: 0.648438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.315613%, 13.861084%, 100%)",
    offset: 0.652344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.390381%, 13.160706%, 100%)",
    offset: 0.65625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.465149%, 12.458801%, 100%)",
    offset: 0.660156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.541443%, 11.756897%, 100%)",
    offset: 0.664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.616211%, 11.054993%, 100%)",
    offset: 0.667969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.690979%, 10.354614%, 100%)",
    offset: 0.671875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.765747%, 9.65271%, 100%)",
    offset: 0.675781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.842041%, 8.952332%, 100%)",
    offset: 0.679688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.916809%, 8.250427%, 100%)",
    offset: 0.683594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(6.991577%, 7.548523%, 100%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.066345%, 6.846619%, 100%)",
    offset: 0.691406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.141113%, 6.14624%, 100%)",
    offset: 0.695312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.215881%, 5.444336%, 100%)",
    offset: 0.699219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.292175%, 4.743958%, 100%)",
    offset: 0.703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.366943%, 4.042053%, 100%)",
    offset: 0.707031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.441711%, 3.341675%, 100%)",
    offset: 0.710938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.516479%, 2.639771%, 100%)",
    offset: 0.714844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.591248%, 1.937866%, 100%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.666016%, 1.235962%, 100%)",
    offset: 0.722656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.74231%, 0.535583%, 100%)",
    offset: 0.726562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.769775%, 0.267029%, 100%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 0%, 100%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 0%, 100%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(7.798767%, 0%, 100%)",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id5)",
    d: "M 328.40625 245.617188 L 328.082031 35.007812 L 194.675781 34.804688 L 194.996094 245.414062 Z M 328.40625 245.617188 ",
    fillRule: "nonzero"
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id10)",
    d: "M 119.9375 240.472656 L 120.167969 166.25 L 15.886719 166.574219 L 15.65625 240.796875 Z M 119.9375 240.472656 ",
    fillRule: "nonzero"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id12)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id13)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#id14)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#id15)",
    d: "M 170.496094 -17.847656 L -47.390625 200.039062 L 170.496094 417.925781 L 388.382812 200.039062 Z M 170.496094 -17.847656 ",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarity2);
export default __webpack_public_path__ + "static/media/polarity2.13c94064.svg";
export { ForwardRef as ReactComponent };